import { Navigate, RouteObject } from "react-router-dom";
import Dashboard from "@/pages/backoffice/Dashboard";
import Associations from "@/pages/backoffice/Associations";
import AssociationDetail from "@/pages/backoffice/AssociationDetail";
import AssociationEdit from "@/pages/backoffice/AssociationEdit";
import AssociationNew from "@/pages/backoffice/AssociationNew";
import Documents from "@/pages/backoffice/Documents";
import DocumentDetail from "@/pages/backoffice/DocumentDetail";
import DocumentCreate from "@/pages/backoffice/DocumentCreate";
import DocumentEdit from "@/pages/backoffice/DocumentEdit";
import DocumentTypes from "@/pages/backoffice/DocumentTypes";
import DocumentTypeCreate from "@/pages/backoffice/DocumentTypeCreate";
import DocumentTypeEdit from "@/pages/backoffice/DocumentTypeEdit";
import Users from "@/pages/backoffice/Users";
import Orders from "@/pages/backoffice/Orders";
import OrderDetail from "@/pages/backoffice/OrderDetail";
import Properties from "@/pages/backoffice/Properties";
import PropertyForm from "@/pages/backoffice/PropertyForm";
import PropertyBulkForm from "@/pages/backoffice/PropertyBulkForm";
import Settings from "@/pages/backoffice/Settings";
import Pricing from "@/pages/backoffice/Pricing";
import PricingTableDetail from "@/pages/backoffice/PricingTableDetail";
import PricingTableNew from "@/pages/backoffice/PricingTableNew";
import FeesApportionParties from "@/pages/backoffice/FeesApportionParties";
import FeesApportionPartyDetail from "@/pages/backoffice/FeesApportionPartyDetail";
import Payouts from "@/pages/backoffice/Payouts";
import Analytics from "@/pages/backoffice/Analytics";
import AnalyticsDashboard from "@/pages/backoffice/AnalyticsDashboard";
import DashboardBuilder from "@/pages/backoffice/DashboardBuilder";
import NotFound from "@/pages/NotFound";
import OrderRequestedDocument from "@/pages/backoffice/OrderRequestedDocument";
import OrderDocumentOutput from "@/pages/backoffice/OrderDocumentOutput";
import CMS from "@/pages/backoffice/CMS";
import UserEdit from "@/pages/backoffice/UserEdit";
import UserInvite from "@/pages/backoffice/UserInvite";
import ManagementCompanies from "@/pages/backoffice/ManagementCompanies";
import ManagementCompanyEdit from "@/pages/backoffice/ManagementCompanyEdit";
import { DocumentQueueMonitor } from "@/components/DocumentQueueMonitor";
import BackofficeLayout from "@/components/layouts/BackofficeLayout";
import FinancialTransactions from "@/pages/backoffice/FinancialTransactions";
import FinancialAccounts from "@/pages/backoffice/FinancialAccounts";

const backofficeRoutes: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to="/backoffice/dashboard" />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/associations",
    element: <Associations />,
  },
  {
    path: "/associations/new",
    element: <AssociationNew />,
  },
  {
    path: "/associations/:id",
    element: <AssociationDetail />,
  },
  {
    path: "/associations/:id/edit",
    element: <AssociationEdit />,
  },
  {
    path: "/associations/:associationId/properties/:id/edit",
    element: <PropertyForm />,
  },
  {
    path: "/documents",
    element: <Documents />,
  },
  {
    path: "/documents/new",
    element: <DocumentCreate />,
  },
  {
    path: "/documents/:id",
    element: <DocumentDetail />,
  },
  {
    path: "/documents/:id/edit",
    element: <DocumentEdit />,
  },
  {
    path: "/document-types",
    element: <DocumentTypes />,
  },
  {
    path: "/document-types/new",
    element: <DocumentTypeCreate />,
  },
  {
    path: "/document-types/:id",
    element: <DocumentTypeEdit />,
  },
  {
    path: "/users",
    element: <Users />,
  },
  {
    path: "/users/:id/edit",
    element: <UserEdit />,
  },
  {
    path: "/users/invite",
    element: <UserInvite />,
  },
  {
    path: "/orders",
    element: <Orders />,
  },
  {
    path: "/orders/:id",
    element: <OrderDetail />,
  },
  {
    path: "/orders/:orderId/documents/:documentId",
    element: <OrderRequestedDocument />,
  },
  {
    path: "/orders/:orderId/documents/:documentId/output",
    element: <OrderDocumentOutput />,
  },
  {
    path: "/properties",
    element: <Properties />,
  },
  {
    path: "/properties/add",
    element: <PropertyForm />,
  },
  {
    path: "/properties/bulk-add",
    element: <PropertyBulkForm />,
  },
  {
    path: "/properties/:id/edit",
    element: <PropertyForm />,
  },
  {
    path: "/settings",
    element: <Settings />,
  },
  {
    path: "/pricing",
    element: <Pricing />,
  },
  {
    path: "/pricing/new",
    element: <PricingTableNew />,
  },
  {
    path: "/pricing/:id",
    element: <PricingTableDetail />,
  },
  {
    path: "/fees-apportion-parties",
    element: <FeesApportionParties />,
  },
  {
    path: "/fees-apportion-parties/:id",
    element: <FeesApportionPartyDetail />,
  },
  {
    path: "/payouts",
    element: <Payouts />,
  },
  {
    path: "/analytics",
    element: <Analytics />,
  },
  {
    path: "/analytics/new",
    element: <DashboardBuilder />,
  },
  {
    path: "/analytics/:id/edit",
    element: <DashboardBuilder />,
  },
  {
    path: "/analytics/:id",
    element: <AnalyticsDashboard />,
  },
  {
    path: "/transactions",
    element: (
      <BackofficeLayout>
        <FinancialTransactions />
      </BackofficeLayout>
    ),
  },
  {
    path: "/financial-accounts",
    element: (
      <BackofficeLayout>
        <FinancialAccounts />
      </BackofficeLayout>
    ),
  },
  {
    path: "/cms",
    element: <CMS />,
  },
  {
    path: "/management-companies",
    element: <ManagementCompanies />,
  },
  {
    path: "/management-companies/new",
    element: <ManagementCompanyEdit />,
  },
  {
    path: "/management-companies/:id",
    element: (
      <Navigate to="/backoffice/management-companies/:id/edit" replace />
    ),
  },
  {
    path: "/management-companies/:id/edit",
    element: <ManagementCompanyEdit />,
  },
  {
    path: "/queue-monitor",
    element: (
      <BackofficeLayout>
        <DocumentQueueMonitor />
      </BackofficeLayout>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default backofficeRoutes;
